import HttpService from "./HttpService";

export default {
  registrarVisita(datos) {
    return HttpService.registrar("metricas.php", {
      accion: "registrar_visita",
      ...datos,
    });
  },
  registrarVistaProducto(datos) {
    return HttpService.registrar("metricas.php", {
      accion: "registrar_vista_producto",
      ...datos,
    });
  },
  registrarTiempoVisita(datos) {
    return HttpService.registrar("metricas.php", {
      accion: "registrar_tiempo_visita",
      ...datos,
    });
  },
};
